module.exports = __webpack_public_path__ + "assets/d0455239352560c8032225a615ca5f3a.mp3";